import React from 'react'

const Electronicbrand = () => {
  return (
    <>
            <div id='display-phone'>
<h5 style={{borderBottom:'3px solid #B3DDEF'}}>Top  <span style={{color:'#B3DDEF',}}>Electronic Brands</span></h5>
<h5 style={{borderBottom:'3px solid black'}}>See All</h5>
 </div>
 
 <div id='Electronicbrand-wrapper'>


      <div id='Electronicbrand-container'>
        <div id='shape-design'></div>

        <div id='shape-design2'></div>

        <div id='Electronicbrand-text-wrapper'>
    <h3>IPHONE</h3>
    <img src="/asset/applelogo.PNG" alt="" srcset="" />
     <p>Up to 80% Off</p>
        </div>

        <div id='Electronicbrand-image-wrapper'>
           <img src="/asset/iphonex.PNG" alt="" srcset="" />

        </div>
        
      </div>

        <div style={{backgroundColor:'#fff3cc'}} id='Electronicbrand-container'>
        <div style={{backgroundColor:'rgb(245, 221, 141)'}} id='shape-design'></div>

        <div style={{border:'2px solid rgb(245, 221, 141)'}} id='shape-design2'></div>

        <div  id='Electronicbrand-text-wrapper'>
    <h3 style={{backgroundColor:'rgb(238, 215, 136)',color:'black'}}>REALME</h3>
    <h3 style={{backgroundColor:'rgb(255, 201, 21)',color:'black',borderRadius:'5px,',}}>realme</h3>
     <p style={{color:'black',fontSize:'24px'}}>Up to 80% Off</p>
        </div>

        <div id='Electronicbrand-image-wrapper'>
           <img src="/asset/real.PNG" alt="" srcset="" />

        </div>
        
      </div>

        <div style={{backgroundColor:'rgb(255, 236, 223)'}} id='Electronicbrand-container'>
        <div style={{backgroundColor:'rgb(254, 208, 175)'}} id='shape-design'></div>

        <div style={{border:'2px solid rgb(254, 208, 175)'}} id='shape-design2'></div>

        <div id='Electronicbrand-text-wrapper'>
    <h3>Xiaomi</h3>
    <img style={{borderRadius:'100%'}} src="../src/assets/xiaomi.png" alt="" srcset="" />
     <p style={{color:'black',fontSize:'23px'}}>Up to 80% Off</p>
        </div>

        <div id='Electronicbrand-image-wrapper'>
           <img src="/asset/12.PNG" alt="" srcset="" />

        </div>
         </div>
      </div>
    </>
  
  )
}

export default Electronicbrand